import { getCorrespondent as getCorrespondentApi } from '../api'
import { uniqueId } from 'lodash'
import { Dispatch } from 'redux'
import { AxiosResponse } from 'axios'

export const GET_CORRESPONDENT = uniqueId('GET_CORRESPONDENT')
export const GET_CORRESPONDENT_SUCCESS = uniqueId('GET_CORRESPONDENT_SUCCESS')
export const GET_CORRESPONDENT_FAILURE = uniqueId('GET_CORRESPONDENT_FAILURE')

export const getCorrespondent = (dispatch: Dispatch, accountNumber: string) => {
  dispatch({ type: GET_CORRESPONDENT, accountNumber })
  getCorrespondentApi(accountNumber)
    .then((response: AxiosResponse) => {
      const {
        data: [{ code, name }],
      } = response
      dispatch({ type: GET_CORRESPONDENT_SUCCESS, correspondent: { code, name } })
    })
    .catch((error: Error) => {
      dispatch({ type: GET_CORRESPONDENT_FAILURE, error })
    })
}
